<form class="profile-form" [formGroup]="form">
  <!-- Back Button -->
  <div class="back-link" (click)="onBack()">
    <wm-common-text
      [data]="{ text: '< Back', fontFamily: 'roboto' }"
    ></wm-common-text>
  </div>

  <!-- Page Title -->

  <div class="title-container">
    <wm-common-text
      [data]="{ text: 'Edit Profile', fontFamily: 'roboto' }"
    ></wm-common-text>
  </div>

  <!-- =======================
       NAME SECTION
  ======================== -->
  <section class="form-section">
    <div class="section-title">
      <wm-common-text
        [data]="{ text: 'Name', fontFamily: 'roboto' }"
      ></wm-common-text>
    </div>

    <wm-common-textfield
      [data]="{
        label: 'Full name',
        placeholder: 'Full name',
        required: true,
        value: form.value.fullName,
        helperText: getError('fullName'),
        onChange: onFullNameChange.bind(this)
      }"
      formControlName="fullName"
      (valueChange)="onFullNameChange($event)"
    ></wm-common-textfield>
  </section>

  <!-- Start Code added by Sanchit on 09/06/2026 -->
  <!-- =======================
       USERNAME SECTION
  ======================== -->
  <section class="form-section">
    <div class="section-title">
      <wm-common-text
        [data]="{ text: 'User name', fontFamily: 'roboto' }"
      ></wm-common-text>
    </div>

    <wm-common-textfield
      [data]="{
        label: 'User name',
        placeholder: 'User name',
        required: true,
        value: form.value.userName,
        helperText: getError('userName'),
        onChange: onUserNameChange.bind(this)
      }"
      formControlName="userName"
      (valueChange)="onUserNameChange($event)"
    ></wm-common-textfield>
  </section>
  <!-- End Code added by Sanchit on 09/06/2026 -->

  <!-- =======================
       ADDRESS SECTION
  ======================== -->
  <section class="form-section">
    <div class="section-title">
      <wm-common-text
        class="section-title"
        [data]="{ text: 'Address' }"
      ></wm-common-text>
    </div>

    <div class="two-column">
    <wm-common-textfield
      [data]="{
        label: 'Street address',
        required: true,
        value: form.value.streetAddress,
        helperText: getError('streetAddress'),
        onChange: onStreetAddressChange.bind(this)
      }"
      formControlName="streetAddress"
      (valueChange)="onStreetAddressChange($event)"
    ></wm-common-textfield>
</div>

    <div class="two-column">
      <wm-common-textfield
        [data]="{
          label: 'City',
          value: form.value.city,
          onChange: onCityChange.bind(this)
        }"
        formControlName="city"
        (valueChange)="onCityChange($event)"
      ></wm-common-textfield>

      <wm-common-textfield
        [data]="{
          label: 'State',
          value: form.value.state,
          onChange: onStateChange.bind(this)
        }"
        formControlName="state"
        (valueChange)="onStateChange($event)"
      ></wm-common-textfield>
    </div>

    <wm-common-textfield
      [data]="{
        label: 'Zip',
        value: form.value.zip,
        onChange: onZipChange.bind(this)
      }"
      formControlName="zip"
      (valueChange)="onZipChange($event)"
    ></wm-common-textfield>
  </section>

  <!-- =======================
       CONTACT SECTION
  ======================== -->
  <section class="form-section">
    <div class="section-title">
      <wm-common-text
        class="section-title"
        [data]="{ text: 'Contact' }"
      ></wm-common-text>
    </div>

    <div class="two-column">
      <wm-common-textfield
        [data]="{
          label: 'Phone',
          value: form.value.phone,
          onChange: onPhoneChange.bind(this)
        }"
        formControlName="phone"
        (valueChange)="onPhoneChange($event)"
      ></wm-common-textfield>

      <wm-common-textfield
        [data]="{
          label: 'Alt Phone',
          value: form.value.phone2,
          onChange: onAltPhoneChange.bind(this)
        }"
        formControlName="phone2"
        (valueChange)="onAltPhoneChange($event)"
      ></wm-common-textfield>
    </div>

    <wm-common-textfield
      [data]="{
        label: 'Email',
        required: true,
        value: form.value.email,
        helperText: getError('email'),
        onChange: onEmailChange.bind(this)
      }"
      formControlName="email"
      (valueChange)="onEmailChange($event)"
    ></wm-common-textfield>
  </section>


  <!-- SAVE / CANCEL BUTTONS -->
  <div class="btn-row">
    <!-- CANCEL -->
    <div class="cancel-btn">
      <wm-common-button
        [data]="{
      text: 'CANCEL',
      onClick: onCancel.bind(this)
    }"
      ></wm-common-button>
    </div>

    <!-- SAVE -->
    <div class="save-btn">
      <wm-common-button
        [data]="{
      text: 'SAVE',
      disabled: isSaving,
      onClick: onSubmit.bind(this)
    }"
      ></wm-common-button>
    </div>
  </div>
</form>
